'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _feisList = require('../../feis-list');

var _feisList2 = _interopRequireDefault(_feisList);

var _starHelp = require('../../feis-list/star-help');

var _starHelp2 = _interopRequireDefault(_starHelp);

var _one = require('./one');

var _one2 = _interopRequireDefault(_one);

var _create = require('./create');

var _create2 = _interopRequireDefault(_create);

var _completed = require('./completed');

var _completed2 = _interopRequireDefault(_completed);

var _getFeatureFlags = require('ifeis-isomorphic/lib/redux/actions/feature-flags/getFeatureFlags');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeiseannaController = function FeiseannaController(config, fFeisService, $ngRedux) {
  var _this = this;

  _classCallCheck(this, FeiseannaController);

  this.config = config;
  this._ = { fFeisService: fFeisService };

  if (window.location.href.endsWith('feiseanna') || window.location.href.endsWith('feiseanna/completed')) {
    $ngRedux.dispatch((0, _getFeatureFlags.getFeatureFlags)()).then(function (response) {
      if (response.payload && response.payload.flags.isCrossNavigationEnabled) {
        window.location.replace(IFEIS_APPV2_URI + '/feiseanna-list');
      }
    });
  }

  this.loading = true;

  fFeisService.all({ params: { include_past: 0, is_finalized: 0 } }).then(function (feiseanna) {
    _this.feiseanna = feiseanna;
    _this.loading = false;
  }).catch(function () {
    return _this.loading = false;
  });
};

exports.default = angular.module('ifeis.routes.feiseanna', ['ui.router', 'ngMaterial', 'ifeis.feis-list', 'ifeis.feis-star', 'ifeis.routes.feiseanna.create', 'ifeis.routes.feiseanna.completed', 'ifeis.routes.feiseanna.one']).config(function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('feiseanna', {
    url: '/feiseanna',
    controller: 'FeiseannaController',
    controllerAs: 'feiseanna',
    template: require('./tpl.html'),
    ncyBreadcrumb: {
      label: 'Feiseanna'
    }
  });
}).controller('FeiseannaController', FeiseannaController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/index.js
// module id = 219
// module chunks = 0